import * as React from "react";
import { Box } from "@mui/system";
import { useStyles } from "../../events/styles/index.styles";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { Divider, Grid } from "@mui/material";
import StationItem from "./StationItem";
import "moment/locale/pt-br";
import StationsService from "../../services/StationsService";


export default function StationsList({ event, stations }: any) {
  const styles = useStyles();
  const { t } = useTranslation();

  // Loader para students_list
  const [studentsListByStation, setStudentsListByStation] = React.useState<{ [key: string]: any[] }>({});
  const [loadingStudents, setLoadingStudents] = React.useState<{ [key: string]: boolean }>({});

  // Função para buscar students_list via API
  const fetchStudentsList = async (stationId: any) => {
    setLoadingStudents(prev => ({ ...prev, [stationId]: true }));
    try {
      const response = await StationsService.getUsersStations(stationId);

      setStudentsListByStation(response.data);
    } catch {
      setStudentsListByStation(prev => ({ ...prev, [stationId]: [] }));
    } finally {
      setLoadingStudents(prev => ({ ...prev, [stationId]: false }));

    }
  };

  // Efeito para buscar students_list das estações onde evaluated é appraiser
  React.useEffect(() => {
    if (Array.isArray(stations)) {
      stations
        .filter(station =>
          Array.isArray(station.appraisers_list) &&
          station.appraisers_list.some((appraiser: any) => appraiser.id === station?.evaluated?.user_id)
        )
        .forEach(station => {
          if (!studentsListByStation[station.station_id]) {
            fetchStudentsList(station.station_id);
          }
        });
    }
    // eslint-disable-next-line
  }, [stations]);

  return (
    <Box className={styles.container}>
      <Typography
        component="div"
        className={styles.titleCard}
        sx={{ fontWeight: 700, fontSize: 35 }}
      >
        {t("title_page_form_station_management")}
      </Typography>

      <Divider className={styles.dividerStation} />
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("list_event_station_namestation")}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("table_theme_label_name")}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("table_station_list_appraiser")}</Typography>
          </Grid>

          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("table_station_list_performance")}</Typography>
          </Grid>

          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("title_result")}</Typography>
          </Grid>

          <Grid item xs={2}>
            <Typography sx={{ fontWeight: "bold" }}>{t("table_station_list_action")}</Typography>
          </Grid>
        </Grid>
        <Box sx={{ mb: 5 }}>
          <Divider />
        </Box>
        {/* Listagem padrão */}
        {Array.isArray(stations) &&
          stations.length > 0 &&
          stations?.map((station, index) => (
            <StationItem
              key={"station-" + index}
              station={station}
              eventId={event?.id}
              event={event}
              stationId={station?.station_id}
              evaluated={station?.evaluated}
              appraisers={station?.appraisers}
            />
          ))}
      </Box>
    </Box>
  );
}
